import { render, staticRenderFns } from "./edit-delivery.vue?vue&type=template&id=52ececfb"
import script from "./edit-delivery.vue?vue&type=script&lang=js"
export * from "./edit-delivery.vue?vue&type=script&lang=js"
import style0 from "./edit-delivery.vue?vue&type=style&index=0&id=52ececfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports